import React from 'react'
import { Grid, Box, Typography, Chip } from '@mui/material'
import { ModalSeeker, TooltipSeeker } from '@ui-seeker/core'
import { isEmpty } from '@ui-seeker/utils'

import { skuGroupDetailModalFilters } from '../@signals'


function ChipList({ label, items = [] }) {
    return (
        <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="subtitle2" sx={{ mr: 0.5, fontSize: '0.8rem' }}>
                    {label}:
                </Typography>
                {items.map((name, i) => (
                    <TooltipSeeker key={i} title={name}>
                        <Chip
                            label={name}
                            size="small"
                            sx={{ maxWidth: 200, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }}
                        />
                    </TooltipSeeker>
                ))}
            </Box>
        </Grid>
    )
}

export default function SkuGroupDetailModal() {
    const data = skuGroupDetailModalFilters.value

    return (
        <ModalSeeker
            isOpen={!isEmpty(data)}
            controller={() => { skuGroupDetailModalFilters.value = {} }}
            size="md"
            hideActions
            title={`Group Details — ${data.name || ''}`}
        >
            <Grid container spacing={3}>
                <ChipList label="SKUs" items={data.skuNames} />
                <ChipList label="Users" items={data.userNames} />
            </Grid>
        </ModalSeeker>
    )
}
